import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ArticleDetailsComponent } from './article-details.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: '', component: ArticleDetailsComponent }
    ])
  ],
  exports: [RouterModule]
})
export class ArticleDetailsRoutingModule { }
